import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useI18n from '@/mixins/useI18n';
import { getTypeStyle, getDisplaySubtitle } from '../teamTypeStyles';
import { FeaturedTeamMemberWithBio } from '../teamMembers.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamCard',
  props: {
    teamMember: null
  },
  emits: ['open'],
  setup(__props: any, { emit }) {

const props = __props as {
  teamMember: FeaturedTeamMemberWithBio;
};





const { locale } = useI18n();

const isInteractive = computed(() => props.teamMember.bio?.use === 1);

const typeStyles = computed(() => {
  if (!props.teamMember?.type) return null;
  return getTypeStyle(props.teamMember.type);
});

const subtitle = computed(() => {
  if (!props.teamMember?.type) return '';
  return getDisplaySubtitle(props.teamMember, locale.value);
});

function handleClick(): void {
  if (!isInteractive.value) return;
  emit('open', props.teamMember);
}

return { __sfc: true,props, emit, locale, isInteractive, typeStyles, subtitle, handleClick }
}

})